/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchWAtemplateData = createAsyncThunk('fetchWAtemplateData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget(`api/whatsapp/templates`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const WAtemplateSlice = createSlice({
    name: 'WAtemplateDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWAtemplateData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchWAtemplateData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchWAtemplateData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default WAtemplateSlice.reducer;